import TableRow from '@mui/material/TableRow'
import TableCell from '@mui/material/TableCell'

import RecordsNotFound from '../shared/recordsNotFound/RecordsNotFound'

export function TableNoData({ sx, ...restProps }) {
  return (
    <TableRow>
      <TableCell colSpan={12}>
        <RecordsNotFound
          filled={false}
          sx={[{ py: 10 }, ...(Array.isArray(sx) ? sx : [sx])]}
          {...restProps}
        />
      </TableCell>
    </TableRow>
  )
}
